import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { adminServices } from "../services/AdminServices";
import { ReactComponent as BackIcon } from "../icons/back.svg";
import LoadingModal from "../components/LoadingModal";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import Button from "../components/Button";
import Modal from "react-modal";
import ReactModal from "react-modal";
import { v4 as uuidv4 } from 'uuid';
import InputText1 from "../components/InputText1";
import AlertModal from "../components/AlertModal";
import withAuthorization from "../components/withAuthorization";
import SearchBar from "../components/SearchBar";
import VoidModal from "./VoidModal";
import { logExport } from "../services/ExportLogService";
import { dltService } from "../services/DltService";
const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    width: '30%',
    margin: 'auto',
    height: '60%',
    backgroundColor: 'transparent',
    border: 0
  }
};
const MerchantTransactions = () => {
  const navigate = useNavigate();
  const [merchantId, setMerchantId] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [params, setParams] = useState(null);
  const paramsFromQuery = localStorage.getItem("selectedMerchant");
  const [loading, setLoading] = useState(false);
  const [makeTransfer, setMakeTransfer] = useState(false);
  const [transferAmount, setTransferAmount] = useState(0);
  const [formSeqNo, setFormSeqNo] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidated, setIsValidate] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [showVoid, setShowVoid] = useState(false);
  const [voidRefNo, setVoidRefNo] = useState('');
  const [confirmVoid, setConfirmVoid] = useState(false);
  const [voidMessage, setVoidMessage] = useState('');
  const [toVoid, setToVoid] = useState({});
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
  const [offset, setOffset] = useState(0);
  const limit = 100;
  const [dltStatus, setDltStatus] = useState({
    label: "Checking DLT...",
    tone: "checking",
    message: "Checking chain integrity"
  });
  useEffect(() => {
    if (paramsFromQuery) {
      getQueryParams(atob(paramsFromQuery));
    }
  }, [paramsFromQuery]);
  useEffect(() => {
    if (params) {
      getMerchantTransactions(params.id, offset);
      const merchantCode = params.merchant_code || params.merchantCode;
      if (merchantCode) {
        getDltStatus(merchantCode);
      } else {
        setDltStatus({
          label: "DLT Unavailable",
          tone: "error",
          message: "Merchant code is required for DLT verification"
        });
      }
    }
  }, [params]);
  const getDltStatus = async identifier => {
    setDltStatus({
      label: "Checking DLT...",
      tone: "checking",
      message: "Checking chain integrity"
    });
    try {
      const response = await dltService.checkChainIntegrity(identifier, true);
      const payload = response?.data;
      const chainValid = payload?.valid === true;
      const balanceHashValid = payload?.balanceVerification?.balanceHashValid;
      const balanceMessage = payload?.balanceVerification?.message;
      if (chainValid && balanceHashValid !== false) {
        setDltStatus({
          label: "DLT Verified",
          tone: "valid",
          message: payload?.message || "Chain integrity verified"
        });
        return;
      }
      if (chainValid && balanceHashValid === false) {
        const invalidBalanceMessage = balanceMessage || "Balance hash does not match current state";
        setDltStatus({
          label: invalidBalanceMessage,
          tone: "invalid",
          message: invalidBalanceMessage
        });
        return;
      }
      const invalidChainMessage = payload?.message || "Chain integrity failed";
      setDltStatus({
        label: invalidChainMessage,
        tone: "invalid",
        message: invalidChainMessage
      });
    } catch (error) {
      setDltStatus({
        label: "DLT Unavailable",
        tone: "error",
        message: error?.response?.data?.message || "Unable to verify chain integrity"
      });
    }
  };
  const handleTransactionClick = id => {
    navigate(`/transactions/${id}`);
  };
  const getQueryParams = async str => {
    setLoading(true);
    const json = JSON.parse(str);
    setParams(json);
  };
  const handleButtonClick = e => {
    setToVoid(e);
    // setVoidMessage("Are you sure you want to void this transaction?\n\r" + `${ e.transaction_type} : ${e.amount.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   })}`);
    // setConfirmVoid(true);
    setShowVoid(true);
    //console.log(e);
    setVoidRefNo(e.ref_no);

    //console.log(e);
  };
  const getMerchantTransactions = async (id, o) => {
    setMerchantId(id);
    adminServices.storeProcedure2('get_merchant_transactions_by_id', {
      vMerchantId: id,
      _offset: o,
      _limit: limit
    }).then(response => {
      setTransactions(prevData => [...prevData, ...response.data]);
      setFilteredData(prevData => [...prevData, ...response.data]);
      var _col = [{
        name: 'Transaction Date',
        selector: data => data.timestamp,
        sortable: true
      }, {
        name: 'Reference Number',
        selector: data => data.ref_no,
        sortable: true
      }, {
        name: 'PDL Number',
        selector: data => data.pdl_number,
        sortable: true
      }, {
        name: 'PDL',
        selector: data => data.first_name + " " + data.last_name,
        sortable: true
      }, {
        name: 'Amount',
        selector: data => data && data.amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true
      }, {
        name: 'Remarks',
        selector: data => data.remarks,
        sortable: true
      }, {
        name: 'Action',
        cell: row => {
          const timestampDate = new Date(row.txDate);
          return timestampDate > threeDaysAgo && row.merchant_transaction_type_id == 1 ? <button type="button" onClick={() => handleButtonClick(row)}>Void</button> : null;
        },
        sortable: false
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(error => {
      //console.log(error);
      if (error.status === 401) {
        navigate('/');
      }
    });
  };
  const handleTransfer = () => {
    setMakeTransfer(true);
  };
  const validateForm = () => {
    if (transferAmount <= 0) {
      setIsValidate(false);
      setValidationMessage("Transfer Amount should be at least 1");
      return false;
    }
    if (formSeqNo === "") {
      setIsValidate(false);
      setValidationMessage("Form Sequence Number Required.");
      return false;
    }
    return true;
  };
  const loadMoreTransactions = async () => {
    setOffset(prevOffset => {
      let o = prevOffset + 100;
      getMerchantTransactions(merchantId, o);
      return o;
    }); // Increase offset
  };
  const handleSubmit = async () => {
    if (validateForm() && isValidated) {
      let uuid = uuidv4();
      let refNo = uuid.split('-')[4];
      const payload = {
        merchantId: merchantId,
        amount: parseFloat(transferAmount),
        formNumber: formSeqNo
      };
      const authToken = localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");
      await dltService.postOrderPayment(authToken, payload).then(response => {
        if (response.data && (response.data.status === "202" || response.data.success === true)) {
          setIsSuccess(true);
          setShowAlert(true);
          setAlertMessage("Merchant Fund Transfer to IPX is successful.");
        } else {
          setShowAlert(true);
          setAlertMessage("Error while transferring funds to IPX. Please try again later.");
          setIsSuccess(false);
        }
      }).catch(error => {
        if (error.response?.status === 401) {
          window.location.href = "/";
        } else {
          setShowAlert(true);
          setAlertMessage("Error while transferring funds to IPX. Please try again later.");
          setIsSuccess(false);
        }
      }).finally(() => {
        setMakeTransfer(false);
      });
    }
  };
  const handleClose = () => {
    setShowAlert(false);
    if (isSuccess) {
      window.location.href = "/merchant";
    }
  };
  const exportToCSV = async data => {
    if (!data || data.length === 0) return;

    // Log the export
    await logExport('Merchant Transactions');
    const headers = ['Transaction Date', 'Reference Number', 'PDL Number', 'PDL', 'Amount', 'Remarks'];
    const rows = data.map(row => [row.timestamp, row.ref_no, row.pdl_number || '', `${row.first_name || ''} ${row.last_name || ''}`.trim(), row.amount,
    // raw numeric value
    row.remarks || '']);
    const csvContent = [headers, ...rows].map(row => row.map(field => `"${field}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    const merchantName = params && params.merchant_name ? params.merchant_name.replace(/[^a-z0-9]/gi, '_') : 'Merchant';
    link.setAttribute('download', `MerchantTransactions-${merchantName}-${new Date().toISOString().split('T')[0]}.csv`);
    link.click();
  };
  return <div id="containerM">
        <VoidModal toVoid={toVoid} voidEvent={() => {
      window.location.reload();
    }} refNo={voidRefNo} show={showVoid} onClose={() => {
      setShowVoid(false);
    }} />
        <AlertModal show={showAlert} title="Transfer Funds to IPX" message={alertMessage} onClose={handleClose} />
        <Modal style={customStyles} isOpen={makeTransfer} onRequestClose={() => {
      setMakeTransfer(false);
    }}>
            <div className="card">
                <div className="card-header">Make a Transfer to IPX</div>
                <div className="card-body d-flex flex-column align-item-center">
                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Amount to Transfer"} onChange={e => {
              setValidationMessage("");
              setIsValidate(true);
              if (e.target.value == "e") {
                setIsValidate(false);
                setValidationMessage("Invalid Amount");
              }
              if (e.target.value == "") {
                setIsValidate(false);
                setValidationMessage("Transfer Amount should be at least 1");
              }
              if (e.target.value <= 0) {
                setIsValidate(false);
                setValidationMessage("Transfer Amount should be at least 1");
              }
              if (e.target.value > params.wallet_amount) {
                setIsValidate(false);
                setValidationMessage("Transfer Amount cannot be greater than merchant wallet");
              }
              setTransferAmount(e.target.value);
            }} value={transferAmount} type="number" />
                    </div>
                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Form Sequence Number"} onChange={e => {
              const regex = /^[a-zA-Z0-9]*$/;
              if (regex.test(e.target.value)) {
                setFormSeqNo(e.target.value.toUpperCase());
              }
            }} value={formSeqNo} />
                    </div>

                    {/* <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Remarks"} onChange={(e)=>{
                        setRemarks(e.target.value);
                      }} value={remarks} type="text" />
                     </div> */}

                    <div className="text-danger">
                        {!isValidated && validationMessage}
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <Button variant={"success"} onClick={handleSubmit}>Submit</Button>
                    &nbsp;
                    <Button variant={"danger"} onClick={() => {
            setMakeTransfer(false);
          }}>Cancel</Button>
                </div>
            </div>
        </Modal>


        <LoadingModal show={loading} message={"Loading Merchant Transactions..."} />
        <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    }}>
            <div className="d-flex align-items-center">
              <BackIcon style={{
          cursor: 'pointer',
          marginRight: '10px',
          width: '50px',
          height: '50px'
        }} onClick={() => {
          navigate('/merchant');
        }} />
              <h2>Merchant Transactions ({params && params.merchant_name} - Php {params && params.wallet_amount !== undefined ? params.wallet_amount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) : "0.00"}) </h2>
              <span className={`dlt-status-badge ${dltStatus.tone}`} title={dltStatus.message}>{dltStatus.label}</span>
            </div>

            <div className="d-flex justify-content-end" style={{
        gap: '10px'
      }}>
               <Button variant={"success"} size={"lg"} onClick={() => exportToCSV(filteredData)}> Export to CSV </Button>
               <Button variant={"primary"} size={"lg"} onClick={handleTransfer}> Transfer </Button>
            </div>
        </div>

        <div className="d-flex justify-content-between">
          <div className="flexRow filterDiv">
            <SearchBar placeholder="Search Transactions" onChange={e => {
          const value = e.target.value.toLowerCase();
          const filtered = transactions.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
          setFilteredData(filtered);
        }} />
          </div>
          <div className="ms-auto" style={{
        display: 'flex',
        justifyContent: 'space-around',
        width: 350
      }}>
            <div className="col">
              <div>Displayed Records: <label style={{
              fontWeight: 'bold'
            }}>{transactions.length}</label></div>
            </div>
            <div className="col">
              <a href="javascript:void(0)" onClick={loadMoreTransactions}>Load More</a>
            </div>
          </div>
        </div>
      <br></br>
        
      <div style={{
      height: '500px'
    }}>
        <DataTable columns={columns} data={filteredData} pagination={false} style={{
        height: '550px'
      }} />
      </div>
        
    </div>;
};
export default withAuthorization(MerchantTransactions, 25);